/**
 * MenuLoginContainer component.
 */
import ScreenUtils from '@screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the menu login component.
 */
const MenuLoginContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: ${54 * ScreenUtils.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(MenuLoginContainer);
